import React from "react";
import { Link } from "react-router-dom";
import pagebanner from "../assets/images/pagebanner.png";

const PageBanner = ({ title, breadcrumb = [] }) => {
  return (
    <div
      className="relative w-full h-72 flex items-center  justify-center bg-cover bg-center"
      style={{ backgroundImage: `url(${pagebanner})` }}
    >
      <div className="absolute inset-0 bg-black bg-opacity-60"></div>
      <div className="relative z-10 text-center text-white mt-20">
        <h1 className="text-5xl font-bold">{title}</h1>
        <div className="mt-2 text-sm space-x-1">
          {breadcrumb.map((item, index) => (
            <span key={index} className="inline-block text-lg">
              {index !== 0 && <span className="text-white mx-1">/</span>}
              {item.href ? (
                <Link
                  to={item.href}
                  className={`hover:underline ${
                    index === breadcrumb.length - 1 ? "text-green-400" : "text-white"
                  }`}
                >
                  {item.label}
                </Link>
              ) : (
                <span
                  className={`${
                    index === breadcrumb.length - 1 ? "text-green-400" : "text-white"
                  }`}
                >
                  {item.label}
                </span>
              )}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PageBanner;
